<div class="authority-row authority-row-card">
  <div class="table-column column-authority-line">
    <span class="authority-id"
      ><strong>Authority #{{ authority.ec1Number }}</strong></span
    >
    <span class="authority-rwic">
      RWIC: {{ authority.primaryUserDetail?.eicUserId }} - {{ authority.primaryUserDetail?.eicEmployeeName }}</span
    >
  </div>

  <div class="table-column column-untill">
    <span>Until: {{ authority.expiration | estDate | date: 'MM/dd/yyyy HH:mm' }}</span>
  </div>

  <authority-row [authority]="authority" [showActionButtons]="false" [actionTableVisible]="false" [isAuthorityCard]="true"></authority-row>
</div>
